import * as actions from '../../../store/actions';
import {
    getCollection
} from '../../../constant';

export const getListData = (listName) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.GET_FORM_START
        });
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        firestore.collection(getCollection(profile, listName)).get().then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log("Jassu data : ", data)
            dispatch({
                type: actions.GET_FORM_SUCCESS,
                payload: data
            });
        }).catch((err) => {
            dispatch({
                type: actions.GET_FORM_ERROR,
                payload: err
            })
        })
    }
}

export const saveFormData = (listName, data) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.SAVE_FORM_START
        });
        const firestore = getFirestore();
        const profile = getState().firebase.profile
        const profileUid = getState().firebase.auth.uid

        let fun;

        if (data.id) { //edit
            fun = firestore.update({
                collection: getCollection(profile, listName),
                doc: data.id
            }, {
                ...data,
                updatedAt: new Date(),
                updatedBy: profileUid,
            }, )

        } else { // Create
            delete data.id;
            fun = firestore.add({
                collection: getCollection(profile, listName)
            }, {
                ...data,
                authorDisplayName: (profile.displayName || ''),
                authorId: profileUid,
                createdAt: new Date(),
            }, )
        }

        fun.then(() => {
            dispatch({
                type: actions.SAVE_FORM_SUCCESS,
                payload: data
            });
        }).catch((err) => {
            dispatch({
                type: actions.SAVE_FORM_ERROR,
                payload: err
            })
        })
    }
}

export const resetFormData = () => {
    return (dispatch) => {
        dispatch({
            type: actions.SAVE_FORM_RESET
        });
    }
}